import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Css/Header.css";
import { FaBars, FaTimes } from "react-icons/fa";

const Header = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false); // close menu after clicking
  };

  return (
    <header className="header">
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>
      <div className="logo">ग्रामपंचायत तासगांव</div>

      {/* Hamburger Icon */}
    

      {/* Navigation */}
      <nav className={`nav ${menuOpen ? "open" : ""}`}>
        <ul className="nav-links">
          <li onClick={() => handleNavigate("/")}>मुख्यपृष्ठ</li>
          <li onClick={() => handleNavigate("/locationinfo")}>आमच्याविषयी</li>
          <li onClick={() => handleNavigate("/yashogatha")}>यशोगाथा / उपक्रम</li>
          <li onClick={() => handleNavigate("/gallary")}>गॅलरी</li>
          <li onClick={() => handleNavigate("/abhiyan")}>मुख्यमंत्री अभियान</li>
        </ul>
      </nav>

      <button className="contact-btn" onClick={() => handleNavigate("/contact")}>
        संपर्क करा
      </button>
    </header>
  );
};

export default Header;
